import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../../app/hooks';
import strings, { selectLanguage } from '../../components/localize/localizeSlice';

const CunoBackground: React.FC = () => {
    const [opacity, setOpacity] = useState(1);
    const [isBelowXl, setIsBelowXl] = useState(true); // control opacity only on small screens
    useAppSelector(selectLanguage);

    useEffect(() => {
        const checkScreenSize = () => {
            setIsBelowXl(window.innerWidth < 1600);
        };

        const handleScroll = () => {
            if (!isBelowXl) return;

            const scrollY = window.scrollY;
            const fadeEnd = 300;
            const newOpacity = Math.max(0, 1 - scrollY / fadeEnd);
            setOpacity(newOpacity);
        };

        window.addEventListener('resize', checkScreenSize);
        window.addEventListener('scroll', handleScroll);
        checkScreenSize();
        handleScroll();

        return () => {
            window.removeEventListener('resize', checkScreenSize);
            window.removeEventListener('scroll', handleScroll);
        };
    }, [isBelowXl]);

    return (
        <div className="absolute inset-0 flex">
            <div
                className="w-1/2 bg-black z-[-2]"
                style={{
                    clipPath: 'polygon(0 0, 100% 0, 85% 100%, 0% 100%)',
                }}
            >
                <img
                    src="https://cuno.gmbh/wp-content/uploads/2021/10/logo_white.svg"
                    alt="Cuno Logo"
                    className="absolute top-9 left-9 w-32 h-auto"
                />
                <h1
                    className="absolute top-40 !text-4xl lg:!text-5xl p-4 font-extrabold text-left mb-8 ml-4 z-[2] text-white hidden md:block transition-opacity duration-300 min-[100rem]:opacity-100"
                    style={isBelowXl ? { opacity } : undefined}
                >
                    <span className="relative inline-block">
                        <span className="relative z-10 block">
                            {strings.priceCalculator}
                        </span>
                        <span className="absolute left-0 bottom-[0px] bg-[#0693e3] h-5 w-full -skew-x-12 z-[-1]"></span>
                    </span>
                    <p className="relative lg:w-[500px] xl:w-[600px] sm:w-[400px] min-[100rem]:w-[450px] !text-3xl lg:!text-4xl py-4 font-normal text-left mb-8 z-[2] text-white">
                        {strings.priceCalculatorDescrption}
                    </p>
                </h1>
            </div>

            <video
                className="absolute inset-0 w-full h-full object-cover z-[-3]"
                autoPlay
                loop
                muted
            >
                <source
                    src="https://cuno.gmbh//wp-content/uploads/2021/11/1061402302-hd.mov"
                    type="video/mp4"
                />
                Your browser does not support the video tag.
            </video>
        </div>
    );
};

export default CunoBackground;
